module.exports = function () {
	$(document).ready(function () {
		$('.G3-create-update form').one('submit', function (e) {
			e.preventDefault();
			$(e.currentTarget).find('button[type=submit]').prop('disabled', true);
			var key = $('#g-recaptcha-response').data('key');
			grecaptcha.ready(function () {
				grecaptcha.execute(key,
					{ action: 'submit' }).then(function (token) {
						$('#g-recaptcha-response').val(token);
						$(e.currentTarget).find('button[type=submit]').prop('disabled', false);
						$(e.currentTarget).find('button[type=submit]').click();
					});
			});
		});
	});
};
